import { Header } from "./UI/Header";

const MESH_BLOBS = [
  { color: "#60A5FA", size: 380, top: "12%", left: "8%" },
  { color: "#A78BFA", size: 340, top: "8%", left: "72%" },
  { color: "#3D2C8D", size: 420, top: "68%", left: "45%" },
  { color: "#2563EB", size: 300, top: "40%", left: "85%" },
  { color: "#F8FAFF", size: 360, top: "55%", left: "5%" },
];

function Layout({ children }) {
  return (
    <div className="relative w-full overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <div
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(circle at 20% 30%, #60A5FA 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, #A78BFA 0%, transparent 50%),
              radial-gradient(circle at 50% 80%, #3D2C8D 0%, transparent 60%),
              #F8FAFF
            `,
          }}
        />

        {MESH_BLOBS.map((blob, i) => (
          <div
            key={i}
            className="absolute rounded-full mix-blend-soft-light opacity-40"
            style={{
              backgroundColor: blob.color,
              width: blob.size,
              height: blob.size,
              top: blob.top,
              left: blob.left,
              filter: "blur(160px)",
            }}
          />
        ))}

        <div className="absolute inset-0 opacity-20 mix-blend-overlay">
          <svg width="100%" height="100%">
            <filter id="noiseFilter">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.8"
                numOctaves="3"
                stitchTiles="stitch"
              />
              <feColorMatrix type="saturate" values="0" />
              <feComponentTransfer>
                <feFuncR type="linear" slope="4.5" intercept="-1.5" />
                <feFuncG type="linear" slope="4.5" intercept="-1.5" />
                <feFuncB type="linear" slope="4.5" intercept="-1.5" />
              </feComponentTransfer>
            </filter>
            <rect width="100%" height="100%" filter="url(#noiseFilter)" />
          </svg>
        </div>

        <div className="absolute inset-0 bg-white/25 pointer-events-none" />
      </div>

      <div className="h-screen overflow-hidden">
        <div className="relative z-10 h-full">
          <div className="hidden md:block w-56 h-full absolute left-0 top-0">
            <Header />
          </div>

          <div className="md:hidden">
            <Header />
          </div>

          <main className="h-full overflow-y-auto ml-0 md:ml-56 pt-16 md:pt-3 md:pr-2 md:pb-3">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}

export default Layout;
